import React, { useState, useRef, useEffect } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { getIcons } from '_helpers';

export {ColumnTogglerButton};

function ColumnTogglerButton ({ visibleColumns, toggleColumnVisibility }) {

  const [showColumnToggler, setShowColumnToggler] = useState(false);
  const buttonRef = useRef(null);
  const columnTogglerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  /*const handleToggleDiv = () => {
    setShowColumnToggler(!showColumnToggler);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const buttonWidth = buttonRef.current ? `${buttonRef.current.offsetWidth}px` : 'auto';*/


  const handleToggleDiv = () => {
    setShowColumnToggler(!showColumnToggler);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const buttonWidth = buttonRef.current ? `${buttonRef.current.offsetWidth}px` : 'auto';

  const handleClickOutside = (event) => {
    if (
      buttonRef.current && !buttonRef.current.contains(event.target) &&
      columnTogglerRef.current && !columnTogglerRef.current.contains(event.target)
    ) {
      setShowColumnToggler(false);
    }
  };

  useEffect(() => {
    if (showColumnToggler) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showColumnToggler]);

  return (
    <div className="relative-container">
      <button
        onClick={handleToggleDiv}
        className={`btn-custom ${showColumnToggler ? 'btn-custom-active' : 'btn-custom-inactive'}`}
        ref={buttonRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={isHovered || showColumnToggler ? getIcons('visibilityOutlinedWhite') : getIcons('visibilityOutlinedBlue')}
          alt='icon eye'
          className="btn-custom-icon"
        />
        Afficher les colonnes
      </button>
      {showColumnToggler && (
        <div className="column-toggler" style={{ width: buttonWidth }} ref={columnTogglerRef}>
          {visibleColumns.map((header, index) => (
            header.canToggle && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={header.visible}
                    onChange={() => toggleColumnVisibility(index)}
                    name={header.name}
                    className="custom-checkbox"
                    icon={<span className="custom-icon"></span>}
                    checkedIcon={<span className="custom-checked-icon"><img src={getIcons('checkOutlined')} alt="check icon"/></span>}
                  />
                }
                label={header.label}
              />
            )
          ))}
        </div>
      )}
    </div>
  );
};
